export default class {
  constructor(type, avatar, name, tag) {
    this.type = type;
    this.avatar = avatar;
    this.name = name;
    this.tag = tag;
  }
}
